import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumbs } from 'components/ContainerHeader';
import FeaturePageShell from 'components/shell/FeaturePageShell';
import IntlMessages from 'util/IntlMessages';
import AnalyticsDateRangePicker from './components/AnalyticsDateRangePicker';
import { changeTimeframe } from 'actions';
import SafetyRoute from 'components/kea/SafetyRoute';
import asyncComponent from '../../../../util/asyncComponent';
import LostOpportunities from './LostOpportunities';
import QueryPopular from './QueryPopular';
import QueryNoResult from './QueryNoResult';
import Dashboard from '../dashboard';
import QueryDetail from './QueryDetail';

const Reports = ({ match }) => {
  const dispatch = useDispatch();
  const { analytics: { timeframe } } = useSelector((store) => store);

  const onTimeframeSubmit = (newRange) => dispatch(changeTimeframe(newRange));

  const timeframePicker = (
    <AnalyticsDateRangePicker
      timeframe={timeframe}
      onSubmitRange={onTimeframeSubmit}
    />
  );

  return (
    <FeaturePageShell
      width="expanded"
      title={<IntlMessages id="search.analytics" />}
      actions={timeframePicker}
      secondaryActions={<Breadcrumbs url={match.url} show />}
    >
      <div data-testid="cloud-analytics-container">

        <Switch>
          <SafetyRoute path={`${match.url}/query-popular`} render={() => <QueryPopular match={match} />} />
          <SafetyRoute path={`${match.url}/lost-opportunities`} render={() => <LostOpportunities match={match} />} />
          <SafetyRoute path={`${match.url}/query-no-result`} render={() => <QueryNoResult match={match} />} />

          <SafetyRoute path={[`${match.url}/health`, `${match.url}/dashboard`]} render={(props) => <Dashboard {...props} />} />
          {/* <SafetyRoute path={`${match.url}/filter-popular`} render={() => <FilterPopular />} /> */}
          {/* <SafetyRoute path={`${match.url}/curve`} render={() => <Curve />} /> */}
          {/* <SafetyRoute path={`${match.url}/query-sorted`} render={() => <QuerySorted />} /> */}

          <SafetyRoute path={`${match.url}/query/:query`} render={(props) => <QueryDetail {...props} embedded />} />

          <Route component={asyncComponent(() => import('app/routes/404'))} />
        </Switch>
      </div>
    </FeaturePageShell>
  );
};
export default Reports;
